import ConfidentialityQuestions from './ConfidentialityQuestions';

export default ConfidentialityQuestions; 